import {
    getRecentFilesList,
    BaseFileInformation,
    FileListLoadingStatus,
} from 'owa-group-files-hub-store';
import { getCurrentGroupSmtpAddress } from 'owa-groups-shared-store';
import { computed, IComputedValue } from 'mobx';
import { LogRecentsCompleted } from '../logging/logListLoadPerformanceAndReliability';

export interface RecentFilesViewState {
    smtpAddress: string;
    isLoading: boolean;
    files: BaseFileInformation[];
    cacheListStatus: FileListLoadingStatus;
    refreshListStatus: FileListLoadingStatus;
}

export const getRecentFilesViewState = computed(
    (): RecentFilesViewState | null => {
        const groupSmtpAddress = getCurrentGroupSmtpAddress();
        if (!groupSmtpAddress) {
            return null;
        }

        const recentFilesList = getRecentFilesList(groupSmtpAddress);

        const cacheStatus = recentFilesList.fileListCacheLoadingStatus;
        const refreshStatus = recentFilesList.fileListRefreshLoadingStatus;
        if (
            refreshStatus == FileListLoadingStatus.none &&
            cacheStatus == FileListLoadingStatus.none
        ) {
            return null;
        }

        const files = recentFilesList.fileItems || [];

        // recents is only loading when the status is loading and the store has no files for the groups already.
        // If there are any files available in the store (because group was previously visited in that session), it can displayed on the UI immediately
        const isLoading =
            refreshStatus == FileListLoadingStatus.Loading &&
            recentFilesList.fileItems.length === 0;

        if (!(refreshStatus == FileListLoadingStatus.Loading)) {
            LogRecentsCompleted(
                cacheStatus,
                refreshStatus,
                recentFilesList.fileListCacheErrorStatus,
                recentFilesList.fileListRefreshErrorStatus
            );
        }

        return {
            smtpAddress: groupSmtpAddress,
            isLoading: isLoading,
            files: files,
            cacheListStatus: cacheStatus,
            refreshListStatus: refreshStatus,
        };
    }
);

export type __unused_declarations = IComputedValue<never> | never;
